const ContactDetail = ({ isOpen, onClose, contact }) => {
  return (
    <div className="modal-overlay">
      <div style={{ width: "60vw", height: "50vw" }} className="modal-content">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>
        <h2>{contact.name}</h2>
        <h4>Göndərilmə tarixi : {contact.createdAt.split("T")[0]}</h4>
        <div style={{ width: "100%" }} className="detailmodal-body">
          <h2>Email : {contact.email}</h2>
          <h2>Telefon nömrəsi : {contact.phonenumber}</h2>
          <h2>Mövzu : {contact.subject}</h2>
          <h2 style={{ marginInline: "auto" }}>Mesaj</h2>
          <div
            style={{
              width: "100%",
              marginInline: "auto",
            }}
          >
            {contact.message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetail;
